

let SelectComponent3 = ({data, disabled,selected, onChange}) => {
    //console.log(data);
    return <>
        <div className="mulish-font">
            <select onChange={onChange} disabled={disabled ? true : false} className="py-2 w-full px-[25px] text-black bg-rouzo-blue-light rounded-xl">
                {data ? data.map(d => {
                    return <option className="lota-font text-base " value={d.code}>{d.name}</option>
                }) : ""}
            </select>
        </div>
    </>
}

export default SelectComponent3;